import { Button } from "antd";
import classNames from "classnames";
import HBModel from ".";
import HBIcon from "../HBIcon";
import styles from "./confirm.module.less";
import ModalWrap from "./ModalWrap";
/**
 * @param {{
 * content?: any,
 * title?: any,
 * onOk?: any,
 * okType?: string,
 * okText?: string,
 * okButtonProps?: any,
 * cancelText?: string,
 * cancelType?: string,
 * cancelButtonProps?: any,
 * onCancel?: any,
 * type?: string,
 * hideOkBtn?: boolean,
 * hideCancelBtn?: boolean,
 * hideIcon?: boolean,
 * leftIcon?: any,
 * footerClass?: string,
 * } & import("antd").ModalProps} props
 */
function RawHBConfirm({
  content,
  title,
  onOk,
  okType,
  okText,
  okButtonProps,
  cancelText,
  cancelType,
  cancelButtonProps,
  onCancel,
  type = "warn",
  closable = false,
  hideOkBtn = false,
  hideCancelBtn = false,
  hideIcon = false,
  leftIcon = null,
  footerClass,
  ...props
}) {
  const typeMap = {
    warn: {
      icon: <HBIcon className={styles.warn} type="ic_alert"></HBIcon>,
      okType: "danger",
    },
    success: {
      icon: <HBIcon className={styles.sucess} type="ic_check_circle"></HBIcon>,
      okType: "primary",
    },
  };

  const okButtonType = okType || typeMap[type]?.okType;

  return (
    <HBModel
      {...props}
      footer={null}
      title={null}
      closable={closable}
      width={props.width || 400}
      onCancel={onCancel}
    >
      <div className={styles.title}>
        {leftIcon}
        {title}
        {!hideIcon && typeMap[type].icon}
      </div>
      <div className={styles.content}>{content}</div>
      <div className={classNames(styles.footer, footerClass)}>
        {!hideCancelBtn && (
          <Button
            width="40"
            type={cancelType || "text"}
            onClick={() => {
              onCancel && onCancel();
            }}
            style={{ marginRight: "8px" }}
            {...(cancelButtonProps || {})}
          >
            {cancelText || "取消"}
          </Button>
        )}
        {!hideOkBtn && (
          <Button
            width="40"
            type={okButtonType}
            onClick={() => {
              onOk && onOk();
            }}
            {...(okButtonProps || {})}
          >
            {okText || "删除"}
          </Button>
        )}
      </div>
    </HBModel>
  );
}

const HBConfirm = ModalWrap(RawHBConfirm);
export default HBConfirm;
